import {LqdCarouselHandler} from './lqd-carousel';

class LqdTestimonialCarouselHandler extends LqdCarouselHandler {

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdTestimonialCarouselHandler, { $element } );
}; 